// avstemming-other-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'avh.common.close': 'Cerrar',
  'avh.common.requestDocs': 'Pedir documentación al cliente',
  'avh.common.countOf': '{done} de {total}',
  'avh.common.bookedBalance': 'Saldo contabilizado',
  'avh.common.specDiff': 'Diferencia de especificación',
  'avh.common.docsMissing': 'Falta documentación',
  'avh.common.assessmentRemaining': 'Evaluación pendiente',
  'avh.common.account': 'Cuenta',
  'avh.common.status': 'Estado',
  'avh.common.notSet': 'Sin definir',
  'avh.common.itemsOver90': 'Partidas de más de 90 días',
  'avh.common.itemsOverThreshold': 'Partidas por encima del límite',
  'avh.common.materialityThreshold': 'Límite de materialidad',
  'avh.common.openAdjustments': 'Partidas de conciliación abiertas',
  'avh.common.professionalConfirmation': 'Confirmación profesional',
  'avh.common.reconciliation': 'Conciliación',
  'avh.common.reconciliationItems': 'Partidas de conciliación',
  'avh.common.matches': 'Cuadra',
  'avh.common.confirmed': 'Confirmada',
  'avh.common.conclusion': 'Conclusión',
  'avh.common.overallStatus': 'Estado general',
  'avh.common.remainingRisk': 'Riesgo restante',
  'avh.common.followUpNext': 'Seguimiento del próximo período',
  'avh.common.action': 'Medida',
  'avh.common.professionalChecklist': 'Lista de comprobación profesional',
  'avh.common.openItems': 'Partidas abiertas',
  'avh.common.accountOverview': 'Resumen de cuentas',
  'avh.common.checklist': 'Lista de comprobación',
  'avh.common.postings.one': '{count} asiento',
  'avh.common.postings.other': '{count} asientos',
  'avh.common.items.other': '{count} partidas',
  'avh.common.items.one': '{count} partida',
  'avh.assess.notAssessed': 'Sin evaluar',
  'avh.assess.okGenuine': 'OK – la partida es real y está correctamente registrada',
  'avh.assess.unspecifiedBalance': 'Saldo sin especificar',
  'avh.assess.counterpartyMissing': 'Falta la contraparte',
  'avh.assess.wrongAccrual': 'Periodificación incorrecta',
  'avh.assess.misclassified': 'Cuenta mal clasificada',
  'avh.assess.notGenuine': 'Partida no real',
  'avh.assess.settledAfter': 'Liquidada después del cierre del período',
  'avh.assess.awaitingDocs': 'Pendiente de documentación',
  'avh.assess.awaitingClient': 'Pendiente del cliente',
  'avh.assess.writeDown': 'Deterioro en evaluación',
  'avh.assess.writeOff': 'Se registra como pérdida',
  'avh.assess.followUpNext': 'Seguimiento en el próximo período',
  'avh.level.documented': 'Documentación disponible',
  'avh.level.documentedHint': '¿Existe una factura, un contrato, una confirmación de pago u otro soporte que muestre qué es la partida?',
  'avh.level.existence': 'Existencia confirmada',
  'avh.level.existenceHint': '¿El derecho de cobro o la obligación sigue siendo real en la fecha de conciliación, y no solo está contabilizado?',
  'avh.level.subsequent': 'Liquidación o pago posterior comprobado',
  'avh.level.subsequentHint': '¿Se ha liquidado la partida después del cierre del período, o se ha comprobado que no es así?',
  'avh.level.recoverability': 'Recuperabilidad evaluada',
  'avh.level.recoverabilityHint': '¿Se cobrará el importe y se ha evaluado la necesidad de un deterioro?',
  'avh.flag.over90': 'Más de 90 días',
  'avh.flag.unusualSign': 'Signo inusual',
  'avh.flag.roundAmount': 'Importe redondo',
  'avh.flag.noMovement': 'Sin movimiento en el período',
  'avh.flag.manualPeriodEnd': 'Asiento manual al cierre del período',
  'avh.status.reconciled': 'Conciliada',
  'avh.status.documentedPending': 'Documentada · evaluación pendiente',
  'avh.status.followUp': 'Requiere seguimiento',
  'avh.status.critical': 'Crítica – debe aclararse',
  'avh.status.toAssess': 'Requiere evaluación',
  'avh.dr.accountLine': 'Cuenta {id} {name} · {postings}',
  'avh.dr.closingBalance': 'Saldo final',
  'avh.dr.originalDate': 'Fecha original',
  'avh.dr.lastMovement': 'Último movimiento',
  'avh.dr.age': 'Antigüedad',
  'avh.dr.materiality': 'Materialidad',
  'avh.dr.noThreshold': 'Sin límite definido',
  'avh.dr.overThreshold': 'Por encima del límite',
  'avh.dr.underThreshold': 'Por debajo del límite',
  'avh.dr.controlLevels': 'Niveles de control',
  'avh.dr.levelsNote': 'La partida ya está especificada: se ha leído del libro mayor. Los cuatro anteriores son algo distinto y ninguno sustituye a los demás.',
  'avh.dr.assessment': 'Evaluación',
  'avh.dr.rationale': 'Justificación profesional',
  'avh.dr.rationaleRequired': 'Justificación profesional (obligatoria)',
  'avh.dr.rationalePlaceholder': '¿A qué se refiere la partida, quién es la contraparte y en qué se basa la evaluación?',
  'avh.dr.actionPlaceholder': 'P. ej. Solicita el contrato al cliente, reclasifica a la cuenta 1579 o comprueba el ingreso',
  'avh.dr.followUpDeadline': 'Plazo de seguimiento',
  'avh.dr.lastAssessed': 'Última evaluación: {trail}',
  'avh.dr.needsRationale': 'Esta evaluación requiere una justificación.',
  'avh.dr.saveAssessment': 'Guardar evaluación',
  'avh.cp.counterparty': 'Contraparte',
  'avh.cp.basis': 'Soporte original y documentación',
  'avh.cp.dueDate': 'Vencimiento o fecha prevista de liquidación',
  'avh.cp.subsequent': 'Pago o liquidación posterior',
  'avh.cp.age': 'Antigüedad y movimiento desde el período anterior',
  'avh.cp.recoverable': 'Si el importe sigue siendo real y recuperable',
  'avh.sec.thresholdPositive': 'Escribe el límite de materialidad como un número positivo.',
  'avh.sec.thresholdBasisRequired': 'Escribe en qué se basa el límite. Sin una justificación es solo un número.',
  'avh.sec.basis': 'Base',
  'avh.sec.setBy': 'Definido por',
  'avh.sec.setOn': 'Definido el',
  'avh.sec.thresholdNote': 'El límite indica qué partidas deben evaluarse una a una. No desactiva ningún control: todas las partidas abiertas deben tratarse antes de poder enviar el área a revisión.',
  'avh.sec.noThresholdNote': 'No se ha definido ningún límite de materialidad para este período. Todas las partidas se tratan por igual. El límite es el criterio profesional propio del despacho: la aplicación no sugiere ningún valor.',
  'avh.sec.amountInKroner': 'Importe en coronas',
  'avh.sec.basisPlaceholder': '¿En qué se basa el límite? P. ej. 5 % del resultado antes de impuestos',
  'avh.sec.basisAria': 'Base del límite de materialidad',
  'avh.sec.saveThreshold': 'Guardar límite',
  'avh.sec.removeThreshold': 'Quitar límite',
  'avh.sec.cancel': 'Cancelar',
  'avh.sec.changeThreshold': 'Cambiar límite',
  'avh.sec.setThreshold': 'Definir límite de materialidad',
  'avh.sec.hideRisk': 'Ocultar indicadores de riesgo a evaluar',
  'avh.sec.showRisk': 'Mostrar indicadores de riesgo a evaluar',
  'avh.sec.type': 'Tipo',
  'avh.sec.specified': 'Especificado',
  'avh.sec.documented': 'Documentado',
  'avh.sec.unverified': 'No verificado',
  'avh.sec.oldestItem': 'Partida más antigua',
  'avh.sec.notSpecified': 'Sin especificar',
  'avh.sec.openAccount': 'Abrir cuenta',
  'avh.sec.checkedAgainst': 'Se comprueba con',
  'avh.sec.flaggedItems': 'Partidas con alerta',
  'avh.sec.openingBalance': 'Saldo inicial',
  'avh.sec.movementInPeriod': 'Movimiento del período',
  'avh.sec.specDriftAlert': 'La suma de las partidas especificadas es {specified}, mientras que el libro mayor muestra {booked}. La diferencia de {diff} es saldo sin especificar: normalmente un saldo inicial importado sin asientos subyacentes.',
  'avh.sec.showOpenItems': 'Mostrar partidas abiertas',
  'avh.sec.openAccountWork': 'Abrir el trabajo de la cuenta',
  'avh.sec.noAccounts': 'No se ha añadido ninguna cuenta a otros saldos en este período.',
  'avh.sec.itemsIntro': 'Las partidas se han leído del libro mayor y se han agrupado según a qué se refieren, desde el inicio de la contabilidad hasta el {date} inclusive.',
  'avh.sec.settledOne': 'Se ha liquidado {count} grupo y no se muestra.',
  'avh.sec.settledMany': 'Se han liquidado {count} grupos y no se muestran.',
  'avh.sec.allAccountsInArea': 'Todas las cuentas del área',
  'avh.sec.resetFilters': 'Restablecer filtros',
  'avh.sec.counterpartyDescription': 'Contraparte / descripción',
  'avh.sec.lastMovementLine': ' · último movimiento {date}',
  'avh.sec.actionLine': 'Medida: {action}',
  'avh.sec.viewAssessment': 'Ver evaluación',
  'avh.sec.assess': 'Evaluar',
  'avh.sec.requestDocsShort': 'Pedir documentación',
  'avh.sec.noMatchingItems': 'Ninguna partida coincide con los filtros.',
  'avh.sec.noOpenItems': 'No hay partidas abiertas en las cuentas de esta área.',
  'avh.sec.sumSpecified': 'Suma de partidas especificadas',
  'avh.sec.ageDistribution': 'Distribución por antigüedad',
  'avh.sec.withoutDocs': 'Sin documentación',
  'avh.doc.notRecorded': 'Sin registrar',
  'avh.doc.unknown': 'Desconocido',
  'avh.doc.title': 'Documentación y pista de control',
  'avh.doc.existing': 'Documentos existentes',
  'avh.doc.checked': 'Documentos comprobados',
  'avh.doc.unchecked': 'Documentos sin comprobar',
  'avh.doc.itemsWithoutDocs': 'Partidas sin documentación',
  'avh.doc.document': 'Documento',
  'avh.doc.source': 'Origen',
  'avh.doc.link': 'Vínculo',
  'avh.doc.controlStatus': 'Estado de control',
  'avh.doc.other': 'Otro',
  'avh.doc.client': 'El cliente',
  'avh.doc.firm': 'El despacho',
  'avh.doc.linked': 'Vinculado',
  'avh.doc.notLinked': 'Sin vincular',
  'avh.doc.checkedOne': 'Comprobado',
  'avh.doc.uncheckedOne': 'Sin comprobar',
  'avh.doc.view': 'Ver',
  'avh.doc.reopenCheck': 'Reabrir comprobación',
  'avh.doc.markChecked': 'Marcar como comprobado',
  'avh.doc.empty': 'No se ha adjuntado ningún documento a otros saldos en este período. Usa la pestaña de documentos del panel derecho para adjuntarlos.',
  'avh.doc.missingRequirements': 'Requisitos de documentación pendientes',
  'avh.doc.specCheck': 'Control de especificación',
  'avh.doc.difference': 'Diferencia',
  'avh.doc.sumSpecifiedOpen': 'Suma de partidas abiertas especificadas',
  'avh.doc.notFullySpecified': 'El saldo no está totalmente especificado. La diferencia suele ser un saldo inicial importado sin asientos subyacentes: debe especificarse manualmente en la cuenta.',
  'avh.doc.docAssessmentCheck': 'Control de documentación y evaluación',
  'avh.doc.notFullyDocumented': 'No totalmente documentado',
  'avh.doc.fullyAssessed': 'Totalmente evaluado',
  'avh.doc.documentedBalance': 'Saldo documentado',
  'avh.doc.fullyAssessedBalance': 'Saldo totalmente evaluado',
  'avh.doc.balanceSummary': '{documented} tiene documentación asociada. De esto, {pending} no se ha evaluado por completo en cuanto a su recuperabilidad. Por tanto, el saldo totalmente evaluado profesionalmente es {assessed}.',
  'avh.doc.autoCheck': 'Control automático',
  'avh.doc.doneByPlumme': 'Realizado por Plumme',
  'avh.doc.autoCheckText': 'Plumme ha leído el libro mayor hasta el {date} inclusive y ha comprobado que la suma de las partidas especificadas ({specified}) coincide con el saldo contabilizado ({booked}). Es un control técnico: no confirma que la documentación sea suficiente, que las partidas antiguas sean reales y recuperables, ni que la conciliación esté lista para revisión.',
  'avh.doc.notConfirmed': 'Sin confirmar',
  'avh.doc.confirmText': 'Una persona debe confirmar que la documentación es suficiente, que las partidas antiguas son reales y recuperables, que las periodificaciones son correctas desde el punto de vista profesional, que todas las desviaciones materiales se han tratado y que la conciliación está lista para revisión.',
  'avh.doc.confirmSavedAs': 'La confirmación se guarda como el punto de control «{label}» de la lista de comprobación profesional, en un solo lugar, para que el revisor la encuentre donde la busca.',
  'avh.doc.cannotConfirm': 'No se puede confirmar hasta que se hayan tratado la documentación pendiente, las evaluaciones pendientes y la diferencia de especificación.',
  'avh.doc.confirmCheck': 'Confirmar control profesional',
  'avh.doc.pointMissing': 'El punto de control no existe en la lista de comprobación de este período.',
  'avh.adj.pickAccount': 'Selecciona la cuenta a la que se refiere la partida.',
  'avh.adj.enterAmount': 'Escribe un importe.',
  'avh.adj.enterReason': 'Escribe a qué se debe la partida. Sin una justificación no cuenta como explicada.',
  'avh.adj.description': 'Descripción',
  'avh.adj.date': 'Fecha',
  'avh.adj.amount': 'Importe',
  'avh.adj.classification': 'Clasificación',
  'avh.adj.missingReason': 'Falta la justificación',
  'avh.adj.resolved': 'Resuelta',
  'avh.adj.open': 'Abierta',
  'avh.adj.markUnresolved': 'Marcar como no resuelta',
  'avh.adj.markResolved': 'Marcar como resuelta',
  'avh.adj.delete': 'Eliminar',
  'avh.adj.reasonPlaceholder': '¿A qué se debe la partida?',
  'avh.adj.chooseAccount': 'Elegir cuenta',
  'avh.adj.add': 'Añadir',
  'avh.adj.none': 'No hay partidas de conciliación registradas.',
  'avh.adj.note': 'Las partidas son propuestas de corrección pendientes de aprobación: no se contabiliza nada automáticamente.',
  'avh.derived.documented': 'Todas las partidas abiertas tienen documentación',
  'avh.derived.existence': 'Se ha confirmado la existencia de todas las partidas abiertas',
  'avh.derived.subsequent': 'Se ha comprobado la liquidación posterior',
  'avh.derived.recoverability': 'Se ha evaluado la recuperabilidad de todas las partidas abiertas',
  'avh.derived.old': 'Las partidas de más de 90 días se han evaluado por completo',
  'avh.derived.noCounterparty': 'Las partidas sin contraparte identificada se han aclarado',
  'avh.derived.unusualSign': 'Se han investigado las partidas con signo inusual',
  'avh.derived.manualPeriodEnd': 'Se han evaluado los asientos manuales de cierre del período',
  'avh.ck.noPoints': 'No se ha definido ningún punto de control para otros saldos en este período.',
  'avh.ck.titleReadOnly': 'Lista de comprobación profesional (del preparador, solo lectura)',
  'avh.ck.pointsNote': 'Los puntos se aplican a toda el área. Una marca se guarda en todas las cuentas de otros saldos.',
  'avh.ck.groupItems': 'Partidas que requieren tratamiento',
  'avh.ck.processedOf': '{done} de {total} tratadas',
  'avh.ck.notApplicable': 'No aplica en este período',
  'avh.ck.overThreshold': ' · {count} por encima del límite de materialidad',
  'avh.ck.followsAssessments': 'Se deriva de las evaluaciones',
  'avh.ck.groupPerAccount': 'Por cuenta',
  'avh.ck.itemsAssessed': '{done} de {total} partidas evaluadas por completo',
  'avh.ck.noOpenItems': 'Sin partidas abiertas',
  'avh.ck.notSpecifiedAmount': ' · sin especificar: {amount}',
  'avh.ck.noAccounts': 'No hay cuentas en el área.',
  'avh.ck.groupOverall': 'Evaluaciones profesionales generales',
  'avh.ck.groupReady': 'Preparación final',
  'avh.ck.performedBy': 'Realizado por {name} · ',
  'avh.ck.pointsDone': '{done} de {total} puntos de control completados',
  'avh.bl.unspecified': 'El saldo no está totalmente especificado: {amount} sin explicar',
  'avh.bl.docsMissing': 'Falta la documentación subyacente de {amount}',
  'avh.bl.existenceOne': 'No se ha confirmado la existencia de {count} partida',
  'avh.bl.existenceMany': 'No se ha confirmado la existencia de {count} partidas',
  'avh.bl.recoverability': 'Debe evaluarse la recuperabilidad de {amount}',
  'avh.bl.oldOne': '{count} partida de más de 90 días no se ha tratado por completo',
  'avh.bl.oldMany': '{count} partidas de más de 90 días no se han tratado por completo',
  'avh.bl.adjustmentOne': '{count} partida de conciliación está abierta',
  'avh.bl.adjustmentMany': '{count} partidas de conciliación están abiertas',
  'avh.bl.pointOne': '{count} punto de control no está completado',
  'avh.bl.pointMany': '{count} puntos de control no están completados',
  'avh.bl.criticalNoReason': '{count} desviación crítica carece de justificación',
  'avh.concl.title': 'Conclusión y aprobación',
  'avh.concl.accountsInArea': 'Cuentas del área',
  'avh.concl.documentedNotAssessed': 'Documentado pero no evaluado por completo',
  'avh.concl.incompletePoints': 'Puntos de control incompletos',
  'avh.concl.done': 'Realizada',
  'avh.concl.missing': 'Falta',
  'avh.concl.notReady': 'No está lista para revisión',
  'avh.concl.ready': 'Lista para revisión',
  'avh.concl.placeholder': '¿En qué consisten los saldos, qué se ha documentado y evaluado y qué queda pendiente?',
  'avh.concl.savedAs': 'Se guarda como la justificación del punto de control «{label}».',
  'avh.concl.periodNotLocked': 'El período no está bloqueado: aún se pueden contabilizar justificantes y modificar la base.',
  'avh.concl.periodNotEnded': 'El período no ha terminado. La conciliación se refiere a la base a fecha {date} y debe repetirse tras el cierre del período.',
  'avh.concl.nothingLeft': 'No queda nada que impida enviar el área a revisión. El área no tiene saldo externo: que la especificación sume lo mismo que el libro mayor es un control técnico, y es la evaluación de cada partida la que sustenta la conclusión.',
  'avh.concl.noFollowUps': 'Ninguna evaluación está marcada para seguimiento en el próximo período.',
  'avh.concl.followed': 'En seguimiento',
  'avh.concl.noAction': 'Sin medida anotada',
  'avh.concl.deadline': ' · Plazo {date}',
  'avh.concl.openAssessment': 'Abrir evaluación',
  'avh.concl.sendArea': 'Enviar el área a revisión',
  'avh.concl.leftOne': 'Queda una cosa pendiente antes de poder enviar el área.',
  'avh.concl.leftMany': 'Quedan {count} cosas pendientes antes de poder enviar el área.',
  'avh.quick.needsAssessment': 'Requieren evaluación',
  'avh.quick.allOpen': 'Todas las abiertas',
  'avh.quick.withoutDocs': 'Sin documentación',
  'avh.quick.overThreshold': 'Por encima del límite de materialidad',
  'avh.quick.noMovement': 'Sin movimiento',
  'avh.quick.manualPeriodEnd': 'Manual al cierre del período',
  'avh.quick.fullyAssessed': 'Evaluadas por completo',
  'avh.pg.noRecAccount': 'Otros saldos no tiene ninguna cuenta de conciliación en este período.',
  'avh.pg.accountsCount': '{count} cuentas',
  'avh.pg.toAssess': '{count} por evaluar',
  'avh.pg.documentation': 'Documentación',
  'avh.pg.amountMissing': 'Faltan {amount}',
  'avh.pg.complete': 'Completa',
  'avh.pg.amountUnspecified': '{amount} sin especificar',
  'avh.pg.openCount': '{count} abiertas',
  'avh.pg.notReady': 'No lista',
  'avh.pg.areaLabel': 'Otros saldos',
  'avh.pg.hintUnassessed': '{count} partidas abiertas no se han evaluado por completo.',
  'avh.pg.hintAllAssessed': 'Todas las partidas abiertas se han evaluado por completo.',
  'avh.pg.title': 'Otros saldos: especificación de las cuentas residuales',
  'avh.pg.dataThrough': ' · Datos hasta el {date} inclusive',
  'avh.pg.responsible': ' · Responsable {name}',
  'avh.pg.materialityLine': ' · Límite de materialidad {value}',
  'avh.pg.notSetLower': 'sin definir',
  'avh.pg.needAssessment': '{count} partidas requieren evaluación',
  'avh.pg.noOpenIssues': 'Sin asuntos abiertos',
  'avh.pg.scope': 'El área abarca las cuentas de balance que no se concilian en sus propias áreas de banco, clientes, proveedores, nómina, impuestos y tasas, activos, préstamos o patrimonio neto.',
  'avh.pg.accountCount': 'Número de cuentas',
  'avh.pg.totalAssets': 'Saldo total contabilizado de activos',
  'avh.pg.totalLiabilities': 'Saldo total contabilizado de pasivos',
  'avh.pg.openItemCount': 'Número de partidas abiertas',
  'avh.pg.itemsOlder90': 'Partidas de más de 90 días de antigüedad',
  'avh.pg.settledItems': 'Partidas liquidadas',
  'avh.pg.noExternalBalance': 'Otros saldos no tiene saldo externo. La especificación y el libro mayor son fuentes propias de la empresa, y una partida que nunca fue real aparece en ambos. Por eso la existencia, la contraparte y la recuperabilidad se confirman partida a partida, no porque dos cifras coincidan.',
  'avh.pg.periodOverNotLocked': 'El período ha terminado, pero no está bloqueado. Aún se pueden contabilizar justificantes y modificar la base en la que se apoya la conciliación. Bloquea el período cuando esté terminado.',
  'avh.pg.periodNotEnded': 'El período no ha terminado. Esta es una conciliación provisional a fecha {date}. Los justificantes del resto del mes aún no existen y, tras el cierre del período, hay que obtener el libro mayor definitivo antes de poder finalizar la conciliación.',
  'avh.pg.noAccountsMove': 'No se ha añadido ninguna cuenta a otros saldos en este período. Las cuentas que no corresponden aquí se mueven a su propia área desde el resumen de cuentas.',
  'avh.pg.accountingData': 'Datos contables',
  'avh.pg.fetchedFrom': 'Obtenido del balance de comprobación y del libro mayor',
  'avh.pg.perDate': ' a fecha {date}',
  'avh.pg.kpiAssets': 'Saldo contabilizado de activos',
  'avh.pg.kpiLiabilities': 'Saldo contabilizado de pasivos',
  'avh.pg.kpiPrevious': 'Saldo del período anterior',
  'avh.pg.kpiChange': 'Variación',
});
